import React, { useEffect, useState } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';

interface StripeProviderProps {
  children: React.ReactNode;
  publishableKey: string;
  clientSecret?: string;
}

export const StripeProvider: React.FC<StripeProviderProps> = ({
  children,
  publishableKey,
  clientSecret,
}) => {
  const [stripePromise, setStripePromise] = useState<Promise<any> | null>(null);

  useEffect(() => {
    if (publishableKey) {
      setStripePromise(loadStripe(publishableKey));
    }
  }, [publishableKey]);

  if (!stripePromise) {
    return <div>Loading Stripe...</div>;
  }

  // Configure Elements options for PaymentElement
  // PaymentElement requires either clientSecret or mode to be configured
  const elementsOptions = {
    clientSecret,
  };

  return (
    <Elements stripe={stripePromise} options={elementsOptions}>
      {children}
    </Elements>
  );
};
